<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "PodrucjeTemeBase"
};
</script>

<style scoped>

</style>
